import React from "react";
import { Alert } from "./index";

const AlertRequiredFields = () => {
  const text = (
    <>
      <span className="text-danger fw-bold fs-px-12 align-middle">*</span>{" "}
      indicates a required field.
    </>
  );

  return (
    <Alert
      text={
        <>
          <strong>Note: </strong> {text}
        </>
      }
    />
  );
};

export default AlertRequiredFields;
